import association from './association.svg';
import conditionalSequence from './conditionalSequence.svg';
import dataAssociation from './dataAssociation.svg';
import defaultSequence from './defaultSequence.svg';
import initiatingMessage from './initiatingMessage.svg';
import message from './message.svg';
import nonInitiatingMessage from './nonInitiatingMessage.svg';
import sequence from './sequence.svg';

const flowIcons = {
  sequence,
  message,
  association,
  dataAssociation,
  conditionalSequence,
  defaultSequence,
  initiatingMessage,
  nonInitiatingMessage,
};

export default flowIcons;
